export class CurrentPeriod{
  /* 
  * @type Date
  */
  month;
  
  /* 
  * @type Date
  */
  monthLong;

  /* 
    * @type Date
    */
  year;
  /* 
    * @type string
    */
   period;

   /* 
    * @type string
    */
   locale = "pt-br";  

    /* 
    * @type string
    */
   name = "pt-br";

    /* 
    * @type string
    */
   fullName = "pt-br"; 

   constructor(){
     let today = new Date();
     let month = today.getMonth() + 1;
     this.year = today.getFullYear();     
     this.month = today.toLocaleString(this.locale,{month: "short"});
     this.period = month + "/" + this.year;
     
     this.name = this.capitalizeFirstLetter(this.month + " " + this.year);          
     this.monthLong = today.toLocaleString(this.locale,{month: "long"});
     this.fullName = this.monthLong + " de " + this.year; 
   }

   capitalizeFirstLetter(string){
    return string.charAt(0).toUpperCase() + string.slice(1);
   }
}